import * as AppActions from './App';
import * as ProfileActions from './Profile';
import * as EventActions from './Event';
import { push } from 'connected-react-router'
import axios from '../../shared/axiosConfig';
import config from '../../shared/config';

export const RegistrationActions = {
  SET_ATTRIBUTE: "REGISTRATION_SET_ATTRIBUTE"
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setRegistrationAttribute = (key, value) => {
  return {
    type: RegistrationActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const loadRegistrationData = ( eventId ) => async (dispatch, getState) => {
  console.log("Load reg data");
  dispatch( AppActions.setLoading(true) );
  await axios.get(`/api/events/${eventId}/registration`)
    .then((response) => {
      console.log("Registration response", response);
      dispatch( setRegistrationAttribute('data', response.data));
      dispatch( setRegistrationAttribute('loaded', true));
      dispatch( AppActions.setLoading(false) );
    })
    .catch((error) => {
      console.log("Error loading reg data", error);
    })
}

const setInProgress = (val) => {
  return setRegistrationAttribute('inProgress', val);
}
export const setError = (error) => setRegistrationAttribute('error', error);
export const setLoaded = (state) => setRegistrationAttribute('loaded', state);

export const doRegister = (values) => async (dispatch, getState) => {
  console.log("doRegister");
  let eventId = getState().event.eventId;
  let status = getState().event.data.status;
  dispatch( setInProgress(true) );
  await dispatch(ProfileActions.submitProfile()); // submit profile - create or update

  if( ! getState().profile.successful ) {
    dispatch( setInProgress(false) );
    return; // can't register if profile is not successful
  }

  await axios.post(`/api/events/${eventId}/registration`, {})
    .then( async (res) => {
      console.log("Registration completed");
      await dispatch( fetchRegistration() );
      dispatch( setInProgress(false) );
      dispatch( EventActions.hideRegisterModal() );
      if( (status == 'live') || (status == 'preview') ) {
        dispatch( push(`/events/${config.eventSlug}/lobby`) );
      }
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setInProgress(false) );
      dispatch( setError(err) );
    });
}

export const fetchRegistration = () => async (dispatch, getState) => {
  console.log("Getting peer registration");
  let eventId = getState().event.eventId;
  dispatch( setLoaded(false) );
  await axios.get(`/api/events/${eventId}/registration`)
    .then( (res) => {
      console.log("Received registration", res.data);
      dispatch( setRegistrationAttribute('id', res.data.id) );
      dispatch( setLoaded(true) );
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setError(err) );
    });
}
